
import pic from '@/utils/pic'
const { icon1, icon2, icon3, langzh, langen, langtw, langydl, langpty, langjp,langar, langxby,langdy,langfy,langhy,langty,langyn,zhsz, jtrz, sfrz, iconchecked, iconcheck,icon1_01,icon1_02,icon1_03,icon1_04,banner01,banner02,banner03 } = pic

export default {
  "请输入您的国家":"Vui lòng nhập quốc gia của bạn",
  "借贷审核中":"Khoản vay đang được xem xét",
  "完成":"Hoàn thành càng",
  "可用贷款池":"Nhóm cho vay có sẵn",
  "直观易用的界面":"Giao diện trực quan và dễ sử dụng",
    "访问 3,000 多个市场":"Truy cập hơn 3.000 thị trường",
    "实时更新和价格提醒":"Cập nhật và cảnh báo giá theo thời gian thực",
    "各种技术指标、分析工具和高级图表":"Nhiều chỉ báo kỹ thuật, công cụ phân tích và biểu đồ nâng cao",
    "先进的对冲策略和综合风险管理工具":"Chiến lược phòng ngừa rủi ro tiên tiến và công cụ quản lý rủi ro tích hợp",
  "操作不熟练,试试模拟交易": "Chưa thành thạo? Thử giao dịch mô phỏng",
  "访问我们的帮助中心,获取交易指南": "Truy cập trung tâm trợ giúp để nhận hướng dẫn",
  "希望增进您的交易技巧？": "Muốn cải thiện kỹ năng giao dịch?",
  "每月提取金额": "Số tiền rút hàng tháng",
  "交易者": "Nhà giao dịch",
  "亿": "Trăm triệu",
  "万": "Vạn",
  "3000多种品类供您选择": "Hơn 3000 loại để lựa chọn",
  "24小时交易量":"Khối lượng giao dịch 24 giờ",
  "线上交易,请选择":"Đối với giao dịch trực tuyến, vui lòng chọn",
  "交易所":"trao đổi",
  "3000多种品类,包括加密货币,贵金属,外汇, 原油等等":"Hơn 3.000 danh mục, bao gồm tiền điện tử, kim loại quý, ngoại hối, dầu thô, v.v.",
  "立即交易":"Giao dịch ngay bây giờ",
  "希望增进您的交易技巧":"Muốn cải thiện kỹ năng giao dịch của bạn",
  "访问我们的帮助中心,获取全面交易指南":"Truy cập Trung tâm trợ giúp của chúng tôi để có hướng dẫn giao dịch toàn diện",
  "去看看":"Đi và nhìn xem",
  "操作不熟练,试试我们的模 拟交易功能":"Nếu bạn không có kỹ năng vận hành, hãy thử chức năng giao dịch mô phỏng của chúng tôi",
  "免费体验交易,让您尽快上手":"Hãy thử giao dịch miễn phí để bạn có thể bắt đầu càng sớm càng tốt",
  "马上体验":"Hãy thử ngay bây giờ",
  "充币":"Gửi tiền xu",
  "提币":"Rút xu",
  "客服":"dịch vụ khách hàng",
  "更多":"Hơn",
  "热门品种":"Giống phổ biến",
  "卖出":"bán",
  "买入":"mua",
  "了解我们的平台":"Tìm hiểu về nền tảng của chúng tôi",
  "直观易用":"Trực quan và dễ sử dụng",
  "的界面":"giao diện",
  "定期提供":"Cung cấp thường xuyên",
  "3,000多个市场":"Hơn 3.000 thị trường",
  "的实时更新和 价格警报":"Cập nhật trực tiếp và thông báo giá cho",
  "各种技术指标":"Các chỉ số kỹ thuật khác nhau",
  "分析工具和高级图表":"Công cụ phân tích và biểu đồ nâng cao",
  "套期保值模式和":"mô hình phòng ngừa rủi ro và",
  "风险管理工具":"công cụ quản lý rủi ro",
  "我们创建了技术领先且人性化的交易平台 ,为您提供贴心完善的交易体验":"Chúng tôi đã tạo ra một nền tảng giao dịch thân thiện với người dùng và công nghệ tiên tiến để cung cấp cho bạn trải nghiệm giao dịch chu đáo và đầy đủ.",
  "实时新闻咨询":"Tư vấn tin tức theo thời gian thực",
  "紧跟我们的新闻、产品和活动信息":"Luôn cập nhật tin tức, sản phẩm và sự kiện của chúng tôi",
  "阅读更多新闻":"Đọc thêm tin tức",
  "合作伙伴等最新新闻动态":"Tin tức mới nhất về đối tác và hơn thế nữa",
  "AI智能赚币":"Kiếm tiền thông minh AI",
  "出金":"Rút tiền",
  "随存随取":"Gửi tiền và rút tiền bất cứ lúc nào",
  "一键即刻取出,从不等待":"Lấy nó ra ngay lập tức chỉ bằng một cú nhấp chuột, không bao giờ phải chờ đợi",
  "稳定":"Ổn định",
  "最稳健的理财":"Quản lý tài chính ổn định nhất",
  "稳定收益,您的理财助手":"Thu nhập ổn định, trợ lý tài chính của bạn",
  "执行速度":"Tốc độ thực hiện",
  "极速执行":"Thực hiện cực nhanh",
  "所有订单将以毫秒级别速度执行":"Tất cả các lệnh sẽ được thực hiện ở tốc độ mili giây",
  "每天发放":"Phân phối mỗi ngày",
  "当天产生收益":"Lợi nhuận thu được trong ngày",
  "当天购买当天产生收益,24小时及时发放收益":"Tiền thu được sẽ được tạo ra trong cùng ngày mua và sẽ được phân phối nhanh chóng 24 giờ một ngày",
  "现在就开始":"bắt đầu ngay bây giờ",
  "交易全球金融市场":"Giao dịch thị trường tài chính toàn cầu",
  "支持桌面端与移动端多种方式,您可随时 随地开展交易":"Hỗ trợ nhiều phương thức trên máy tính để bàn và thiết bị đầu cuối di động, bạn có thể thực hiện giao dịch mọi lúc, mọi nơi",
  "谷歌下载":"google tải xuống",
  "下载":"tải về",
  "公司":"công ty",
  "关于我们":"về chúng tôi",
  "许可证监督":"Giám sát giấy phép",
  "帮助中心":"Trung tâm trợ giúp",
  "政策":"chính sách",
  "条款与条件":"Điều khoản và Điều kiện",
  "隐私政策":"chính sách bảo mật",
  "声明":"tuyên bố",
  "法律信息":"thông tin pháp luật",
  "免责声明":"Tuyên bố miễn trừ trách nhiệm",
  "风险警告":"Cảnh báo rủi ro",
  "关于广告":"Về quảng cáo",
  currency: {
    bb: 'Trao đổi',
    bba: 'Tài khoản tiền tệ',
    hy: 'Hợp đồng',
    jg: 'Tùy chọn giao dịch',
    jg1: 'Tương lai',
    hya: 'Tài khoản hợp đồng'
  },
  home:{
    user:'Lựa chọn chung của người dùng',
    start:'Bắt đầu giao dịch',
    trading:'Sản phẩm kinh doanh',
    fee:'Phí xử lý tối thiểu',
    co:'có',
    varieties:'Kinh doanh giống',
    leading:'Dẫn đầu sự đổi mới và khám phá web3',
    market:'Xu hướng thị trường sản phẩm kinh doanh',
    explore:'Khám phá những khả năng vô tận',
    newcurrency:'Chức năng đăng ký tiền tệ mới đang trực tuyến!',
    alimited:'Tiền mới đang trực tuyến, bạn có thể mua tiền mới mà bạn cho là có tiềm năng tại đây',
    get_start:'Bắt đầu',
    ai_coin:'Kế hoạch kiếm tiền AI đang được tiến hành',
    ai_text:'Bắt đầu kiếm xu với AI, thu nhập ổn định, tỷ lệ hoàn vốn cao, cho phép bạn kiếm xu ngay khi nằm',
    loan:'Chức năng cho vay trực tuyến',
    loan_text:'Khi không có tiền, bạn có thể đăng ký vay và sẽ được cấp ngay trong ngày',
    mobile_pc:'Được các y tá sử dụng trên PC di động',
    pc_anytime:'Bắt đầu giao dịch mọi lúc, mọi nơi:',
    pc_text:'Chúng tôi cung cấp các công cụ phân tích biểu đồ mạnh mẽ: hơn 50 chỉ báo kỹ thuật và công cụ phân tích đĩa. Đòn bẩy an toàn, đáng tin cậy, dễ sử dụng và các tính năng đòn bẩy cao đã trở thành nền tảng tiêu chuẩn cho đầu tư trực tuyến.',
    mobile_down:'bấm chuột để tải xuống',
    mobile_android:'Chợ Android',
    mobile_ios:'cửa hàng táo',
    open_text:'Bạn có thể đăng ký tài khoản giao dịch thực hoặc dùng thử tài khoản demo miễn phí với một phần ba chi phí.',
    open_account:'một tài khoản',
    tocomplete:'hoàn thành',
    walletlogin:'Đăng nhập ví'
  },
  index: {
    h24: 'Khối lượng 24 giờ',
    header_title: ['Chọn giao dịch tài sản kỹ thuật số ' + window.GLOBAL.LANG_TITLE.zh],
    header_small_title:'Hoàn thành giao dịch tài sản kỹ thuật số blockchain một cửa',
    header_msg: 'An toàn-ổn định-đáng tin cậy',
    register_title: 'Đăng ký một ' + window.GLOBAL.LANG_TITLE.zh + ' tài khoản toàn cầu bắt đầu hành trình giao dịch',
    register_pl: 'Vui lòng nhập email hoặc điện thoại di động của bạn',
    register: 'Đăng ký',
    featureTitleWhy: 'Tại sao chọn chúng tôi',
    featureTitle: 'An toàn · ổn định · đáng tin cậy',
    featureMsg: '',
    featureList: [
      {icon: icon1, title: 'Công nghệ Ví an toàn', msg: ['Công nghệ ví nóng và lạnh được phát triển bởi nhóm bảo mật hàng đầu thế giới và chưa bao giờ xảy ra sự cố mất tiền. ',' ']},
       {icon: icon2, title: 'kinh doanh tài sản tiền điện tử phong phú', msg: ['hỗ trợ giao ngay và nhiều giao dịch phái sinh, v.v., là người quản lý cá nhân của bạn trong thế giới tài sản tiền điện tử. ',' ']},
       {icon: icon3, title: 'Khách hàng được phân phối trên toàn thế giới', msg: ['Đối với người dùng ở hơn 130 quốc gia hoặc khu vực trên thế giới, chúng tôi cung cấp đầy đủ các dịch vụ tài sản mã hóa. ',' ']}
    ],
    bannerList: [
      {icon: banner01, title: "Cam kết cung cấp sự ổn định và bảo mật hàng đầu trong ngành", msg: ["hợp đồng thông minh để bảo vệ an toàn tài sản của nhà đầu tư", "hiệu suất giao dịch thực", "đảm bảo dịch vụ 24 giờ"]},
      {icon: banner02, title: "Tôi muốn mua và bán ngay lập tức thông qua các thao tác đơn giản", msg: ["màn hình giao dịch đơn giản", "phản ánh ngay lập tức trong số dư tài khoản của bạn", "hầu hết các loại tiền điện tử có thể được giao dịch"]},
      {icon: banner03, title: "Tôi muốn tích cực kiếm lợi nhuận thông qua giao dịch hợp đồng thanh toán", msg: ["Mở tài khoản cùng lúc", "Đầu tư chiến lược cho một số lượng lớn hợp đồng tương lai", "Bạn có thể giao dịch 24 giờ một ngày, 365 ngày một năm, ngay cả vào cuối tuần "]}
    ],
    featureList2: [
      {icon: icon1_01, title: "Minh bạch và cởi mở", msg: ["Sử dụng các đặc điểm của blockchain và hợp đồng thông minh, nhận ra hiệu suất giao dịch trên chuỗi và sử dụng hợp đồng thông minh để đảm bảo an toàn cho tài sản của nhà đầu tư", ""] },
      {icon: icon1_02, title: "Đầu tư Thông minh", msg: ["Với các chiến lược đa dạng được cung cấp bởi các chuyên gia giao dịch định lượng hàng đầu, bạn có thể tự do lựa chọn", ""]},
      {icon: icon1_03, title: "Phân loại rủi ro", msg: ["Thiết kế các sản phẩm đầu tư đa dạng dựa trên các rủi ro khác nhau và sở thích quản lý tài sản của từng nhà đầu tư, loại bỏ hiệu quả các ngưỡng đầu tư", ""]},
      {icon: icon1_04, title: "Sản phẩm đa dạng", msg: ["Cung cấp nhiều loại nhu cầu đầu tư của người dùng và cơ chế nền tảng linh hoạt, đồng thời tiếp tục sản xuất các dịch vụ tài chính sáng tạo tốt hơn thị trường", ""]}
    ],
    featureTitle2: 'Giao dịch đầu cuối đa nền tảng mọi lúc, mọi nơi',
    featureMsg2: 'Bao gồm nhiều nền tảng iOS và Android, hỗ trợ các chức năng đầy đủ dịch vụ',
    tab: ['Tiền tệ chính', 'Danh sách tăng 24H'],
    thead: ['Cặp giao dịch', 'Giá mới nhất', 'Giá cao nhất trong ngày', 'Giá thấp nhất trong ngày', 'Danh sách tăng', 'Khối lượng 24H', 'Hoạt động'],
    more: 'xem thêm >',
    btn: 'Giao dịch',
    dealsTitle: 'Dịch vụ giao dịch một cửa',
    dealsTab:[
      { title: 'Trao đổi', content: 'Giao dịch tiền tệ là để trao đổi giữa các tài sản kỹ thuật số, sử dụng USDT làm đơn vị định giá để mua các loại tiền tệ khác.'+window.GLOBAL.LANG_TITLE.zh+'Giao dịch tiền tệ hỗ trợ giao dịch thời gian thực của các tài sản kỹ thuật số như Bitcoin, Ethereum và Litecoin.', src:'/static/image/deals-1.jpg', path: '' },
      { title: 'Hợp đồng', content: 'Một phái sinh tài chính của tiền kỹ thuật số không chỉ hỗ trợ lựa chọn mua hợp đồng bán dài hoặc bán ngắn để kiếm thu nhập, mà còn vận hành đơn giản và không bao giờ hết hạn.'+window.GLOBAL.LANG_TITLE.zh+'Hợp đồng có hệ thống quản lý rủi ro tiên tiến với đòn bẩy lên đến 100 lần.', src:'/static/image/deals-2.jpg', path: '' }
    ]
  },
  market: {
    tab: ['Tùy chọn', 'Hợp đồng', 'Đồng xu'],
    thead: ['Tiền tệ', 'Giá mới nhất', 'Thay đổi trong 24 giờ', 'Thấp nhất trong 24 giờ', 'Cao nhất 24 giờ', 'Khối lượng 24 giờ', 'Hoạt động'],
    nodata: 'Không có dữ liệu'
  },
  footer: {
    p: '©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
    dd: [
      {
        dt: "Về chúng tôi",
        dd: [{title: "Hồ sơ công ty", id: 1}, {title: "Trung tâm trợ giúp", type: 'help'}]
      },
      {
        dt: "Hỗ trợ người dùng",
        dd: [
          {title: "Thỏa thuận người dùng", id: 3},
          {title: "Chính sách quyền riêng tư", id: 5}
        ]
      },
      {
        dt: "liên hệ chúng tôi",
        icon: true
      }
    ],
    terms: "Các điều khoản và điều kiện",
    serve: "Phục vụ",
    product: "sản phẩm",
  },
  nav: {
    btn: ["Đăng nhập", "Đăng ký", "Quản lý tài sản", "Tải xuống APP"],
    nav: [
      // { title: "Trang chủ", path: "/index",name: 'index' },
      // { title: "Trao đổi", path: "/deal",name: 'deal' },
      { title: "Thị trường", path: "/market",name: 'market' },
      { title: "Buôn bán", path: "/preciousMetal", name: 'preciousMetal'},
      // { title: "Trao đổi", path: "/deal", name: 'deal'},
      // { title: "Hợp đồng", path: "/deal_c", name: 'deal_c' },
      // { title: "Tiền điện tử", path: "/deal_jg", name: 'deal_jg' },
      { title: "Tài chính", path: "/profit_index",name: 'profit_index' },
      // { title: "Hoạt động", path: "/sign",name: 'sign' }
    ],
    nav2: [{ title: "Tài sản của tôi", path: "/asset" }],
    menus: [
      {icon: langzh, title: "Trung tâm Người dùng", path: "/setting"},
      {icon: langen, title: "Đăng xuất"}
    ],
    lang: [
      { icon: langen, lang: "English", key: 'en' },
      { icon: langxby, lang: "España", key: 'es' },
      { icon: langfy, lang: "français", key: 'fr' },
      { icon: langdy, lang: "Deutsche", key: 'de' },
      { icon: langjp, lang: "日本語", key: 'jp' },
      // { icon: langar, lang: "عربي", key: 'ar' },
      { icon: langhy, lang: "한국어", key: 'kr' },
      { icon: langty, lang: "ไทย", key: 'th' },
      { icon: langyn, lang: "Tiếng Việt", key: 'vn' },
  { icon: langydl, lang: "Italia", key: 'it' },
      { icon: langpty, lang: "Portugal", key: 'pt' },
      // { icon: langzh, lang: "简体中文", key: 'zh' },
      { icon: langtw, lang: "繁體中文", key: 'tw' },
    ]
  },
  download:{
    "xz": "Tải xuống"
  },
  // 登录
  // login: {
  //   login: 'Vui lòng đăng nhập',
  //   msg: 'Vui lòng nhập tài khoản đã đăng ký của bạn',
  //   list: ['Di động / Email', 'Mật khẩu', 'Quên mật khẩu?', 'Đăng nhập', 'Không có tài khoản, đăng ký ngay'],
  //   message: 'Tài khoản hoặc mật khẩu không được để trống'
  // },
  register: {
    dl: ['Đăng ký di động', 'Đăng ký email'],
    title: 'Đăng ký tài khoản',
    country: 'Quốc tịch',
    country_info: 'Không thể sửa đổi thông tin quốc tịch sau khi đăng ký, vui lòng đảm bảo chọn trung thực',
    account: 'số tài khoản',
    code_text: 'Mã xác minh',
    code_btn: 'Nhận CAPTCHA',
    code_unit: 's',
    code_no_data: 'mã xác minh phải được điền',
    password_text: 'Vui lòng nhập mật khẩu của bạn',
    password_again_text: 'Mật khẩu lần nữa',
    pid_text: 'Mã mời',
    pid_pl: 'Không bắt buộc',
    invitation_code_no_data: 'Mã lời mời là bắt buộc',
    xy: 'sự thỏa thuận của người dùng',
    xy_no_checked: 'Vui lòng chọn giao thức',
    agree: 'Tôi đã đọc và đồng ý',
    register_btn: 'Đăng ký',
    bz: ['Không thể sửa đổi thông tin quốc tịch sau khi đăng ký, vui lòng đảm bảo chọn trung thực. ',' Email xác minh có thể bị đánh giá sai là thư rác, vui lòng kiểm tra kỹ. ', 'Hãy giữ của bạn' + window.GLOBAL.LANG_TITLE.zh + 'Số tài khoản và mật khẩu đăng nhập.', 'Không sử dụng cùng mật khẩu đăng nhập với các trang web khác.'],
    account_no_data: 'Tài khoản không được để trống',
    code_no_equality: 'Các mã xác minh không bằng nhau',
    password_no_data: 'mật khẩu không được để trống',
    password_no_equality: 'Hai mật khẩu không bằng nhau'
  },
  // 设置密码
  bindmpwd: {
    title: 'đặt mật khẩu',
    account: 'Số tài khoản',
    code_text: 'Mã xác minh',
    code_btn: 'Nhận CAPTCHA',
    code_unit: 's',
    password_text: 'Vui lòng nhập mật khẩu của bạn',
    password_again_text: 'Mật khẩu lần nữa',
    code_no_data: 'mã xác minh phải được điền',
    code_no_equality: 'Các mã xác minh không bằng nhau',
    password_no_data: 'mật khẩu không được để trống',
    password_no_equality: 'Hai mật khẩu không bằng nhau',
    bindmpwd_btn: 'Xác nhận',
    phone_no_data: 'Số điện thoại không được để trống',
    password_login_text: 'Vui lòng nhập mật khẩu đăng nhập',
    password_trade_text: 'Mật khẩu gồm 6 chữ số',
    password_again_tarde_text: 'Mật khẩu gồm 6 chữ số',
  },
  // 忘记密码
  forgetpwd: {
    title: ['Sửa đổi mật khẩu', 'Quên mật khẩu'],
    account: '账号',
    code_text: 'Mã xác minh',
    code_btn: 'Nhận CAPTCHA',
    code_unit: 's',
    password_text: 'Vui lòng nhập mật khẩu của bạn',
    password_again_text: 'Mật khẩu lần nữa',

    phone_no_data: 'Số điện thoại không được để trống',

    account_no_data: 'Tài khoản không được để trống',
    code_no_data: 'mã xác minh phải được điền',
    code_no_equality: 'Các mã xác minh không bằng nhau',
    password_no_data: 'mật khẩu không được để trống',
    password_no_equality: 'Hai mật khẩu không bằng nhau',
    forgetpwd_btn: 'Xác nhận'
  },
  // 绑定手机号码
  bindphone: {
    title: 'Ràng buộc số điện thoại di động',
    phone_text: 'số điện thoại',
  },
  person: {
    more: 'Tải thêm',
    no_more: 'Không có thêm dữ liệu',
    index_center:"Trung tâm người dùng",
    index_menus: [
      { icon: zhsz, title: "Quản lý tài khoản", path: '/setting' },
      { icon: sfrz, title: "Xác thực KYC", path: '/sfyz' },
      { icon: sfrz, title: "Chứng chỉ sơ cấp", path: '/smauth' },
      { icon: sfrz, title: "Đã xác minh", path: '/seniorauth' },
      { icon: jtrz, title: "Xác thực địa chỉ", path: '/dzrz' },
      { icon: jtrz, title: "Mua Tiền mật mã", path: '/kjmbSelect' },
      { icon: jtrz, title: "Điểm tín dụng", path: '/credit' },
      { icon: jtrz, title: "Hồ sơ", path: '/deallog' },
      { icon: jtrz, title: "Hồ sơ tiền ký quỹ", path: '/cbjl' },
      { icon: jtrz, title: "Hồ sơ rút tiền", path: '/tbjl' },
    ],
    cbtb: 'Ký quỹ & Rút tiền',
    jymx: 'Chi tiết giao dịch',
    xyf: {
      'title': 'Điểm tín dụng',
      'pgsj': 'Thời gian đánh giá'
    },
    smrz:{
       title:'Đã xác minh' ,
       sure_title: 'Bạn đã vượt qua xác thực tên thật',
       zj_type: 'Loại chứng chỉ',
       zj_info: ['1, không thể sửa đổi thông tin chứng nhận sau khi đã xác minh, vui lòng điền trung thực', '2, thông tin tên thật đã xác minh không thể được chứng nhận lại'],
       zj_name: 'Tên',
       zj_num: 'số tài liệu',
       zj_btn: 'Được',
       zj_rebtn: 'Xác minh lại',
       zj_sebtn: 'Xác minh nâng cao',
       zj_type_array:[{name:'Thẻ ID',type:'idcard'}],
       idCardArr: [
        {
            id: 1,
            name: "Thẻ ID"
        },
        {
            id: 2,
            name: "Hộ chiếu"
        },
        {
            id: 3,
            name: "Bằng lái xe"
        },
        {
            id: 4,
            name: "giấy phép thường trú"
        },
        {
            id: 5,
            name: "khác"
        }
       ],
       zj_data:{city:'Quốc tịch không được để trống',type:'Loại thông tin xác thực không được để trống',name:'Không được để trống tên',zj_num:'Không được để trống số ID'},
       zsxm: 'Tên thật',
       qsrzsxm: 'Vui lòng nhập tên thật của bạn',
       zjlx: 'Loại ID hợp lệ',
       qxzzjlx: 'Vui lòng chọn loại ID',
       sfz: 'Thẻ ID',
       zjhm: 'Số ID',
       qsrzjhm: 'Vui lòng nhập số ID',
       sczjz: 'Tải lên ảnh ID',
       zjzm: 'Tải lên ảnh mặt trước của tài liệu ID',
       zjfm: 'Tải lên ảnh mặt sau của tài liệu ID',
       qsczjzm: 'Vui lòng tải lên ảnh mặt trước của giấy tờ tùy thân của bạn',
       qsczjfm: 'Vui lòng tải lên ảnh mặt sau giấy tờ tùy thân của bạn',
       scqmz: 'Tải lên các tài liệu ID và chữ ký cá nhân',
       qscscqmz: 'Vui lòng tải lên ID và ảnh chữ ký cá nhân của bạn',
       zj: [
         {
           id: 1,
           title: 'Thẻ ID'
         },
         {
           id: 2,
           title: 'Hộ chiếu'
         },
         {
           id: 3,
           title: 'khác'
         },
       ],
       tj: 'Gửi',
       shz: 'Đang xem xét',
       shtg: 'Đã phê duyệt'
    },
    gjrz:{
      title:'Chứng chỉ cao cấp',
      zj_info:['1. Hỗ trợ các ảnh dưới 8MB và định dạng JPG, JPEG hoặc PNG.','2. Các ảnh tài liệu ID phải rõ ràng và sẽ không bị chỉnh sửa hoặc che khuất. Mã số tài liệu ảnh cá nhân và tên của chủ sở hữu tài liệu phải dễ nhìn.','3. Các ảnh phải được chụp mà không có bất kỳ vật che đầu nào và không khuyến khích trang điểm khi chup. Các đường nét khuôn mặt trong ảnh phải rõ ràng và dễ nhận biết và không để lộ toàn bộ tay.'],
      zj_img:['/static/image/User_Center_Front_view.png','/static/image/User_Center_Back_Shot.png','/static/image/User_Center_Full_picture.png'],

    },
    zhgl:{
      title:'Cài đặt hệ thống bảo vệ',
      bind:[{bind_title: 'Đặt lại mật khẩu', bind_name: 'Email'}, {bind_title: 'Đặt mật khẩu giao dịch', bind_name: 'Email'}]
    },
    wdtg:{
      own_code: 'Mã lời mời độc quyền',
      own_code_url: 'Kết nối lời mời độc quyền',
      own_push_title: 'Quảng cáo của tôi',
      own_push_content: ['Tổng doanh thu từ lời mời (định giá)', 'số lượng lời mời', 'số người'],
      own_push_content_profit: ['Quyền lợi lời mời cấp độ 1', 'Quyền lợi lời mời cấp độ 2', 'Quyền lợi lời mời cấp độ 3', 'Quyền lợi lời mời cấp độ 4'],
      own_push_content_num: ['Số lượng lời mời ở cấp độ đầu tiên', "Số lượng lời mời ở cấp độ thứ hai", "Số lượng lời mời ở cấp độ thứ ba", "Số lượng lời mời ở cấp độ thứ tư"],
      own_push_profit_title: ['ID', 'lợi nhuận', 'thông tin nhận xét', 'thêm thời gian'],
      own_push_num_title: ['ID', 'name', 'phone', 'add time'],
    },
    jyzt_td: ['Thời gian', 'chi tiết', 'lượng'],
    cbjl_td: ['Thời gian', 'tiền tệ', 'số lượng', 'trạng thái'],
    sfrz_txt: ['Xác thực danh tính', 'Bạn đã gửi kiểm tra, vui lòng đợi kết quả', 'Bạn đã vượt qua xác thực nâng cao', 'Mặt trước của thẻ ID', 'Mặt sau của thẻ ID', 'Xác thực', ' Xác thực không thành công, vui lòng xác thực lại '],

    zhsz_txt: ['Cấp độ bảo mật tài khoản của bạn: #', 'Cấp độ bảo mật tài khoản của bạn: #, cải thiện thêm thông tin và đảm bảo bảo mật tài khoản'],
    zhsz_m: 'mạnh',
    zhsz_n: 'yếu',
    zhsz_p: 'không an toàn',
    zhsz_detailList: [
      { icon: '/static/image/User_Center-password.png', title: 'Mật khẩu đăng nhập', value: 'Tài khoản Internet có nguy cơ bị đánh cắp. Bạn nên thay đổi mật khẩu thường xuyên để bảo vệ an toàn cho tài khoản của mình. ', value2:'', btn:'biến đổi', bind_email:' trước tiên hãy liên kết email hoặc điện thoại di động', path: '/forgetpwd?type=changepwd' },
      { icon: '/static/image/User_Center-password.png', title: 'Mật khẩu giao dịch', value: 'Đặt mật khẩu', btn: 'Chuyển đến thiết lập', path: '/bindmpwd' }
    ],
    sksz_txt: ['Cài đặt Biên nhận', 'Lưu'],
    sksz_list: [
      { label: "用户名:", pl: "请输入用户名", key: "name" },
      { label: "开户行名称:", pl: "请输入开户行名称", key: "bank_name" },
      { label: "银行卡号:", pl: "请输入银行卡号", key: "bank_number" },
      { label: "支付宝账号:", pl: "请输入支付宝账号", key: "alipay_account" },
      { label: "微信昵称：", pl: "请输入微信昵称", key: "weixin_nickname" },
      { label: "微信账号：", pl: "请输入微信账号", key: "weixin_account" }
    ]
  },
  pasination: {
    first: 'Trang chủ',
    prev: 'Trang trước',
    next: 'Trang tiếp theo',
    last: 'Trang Cuối cùng',
    no_data: 'Không có dữ liệu',
  },
  asset: {
    title: 'Tài sản của tôi',
    zjhz: 'Chuyển quĩ',
    cb: 'Tiền ký quỹ',
    gz: 'Định giá USDT',
    atnv: [],
    zh_title: 'Tổng tài sản quy đổi：',
    index_title: 'tài sản',
    address_title: 'Tiền tệ',
    address_txt: ['xin vui lòng chọn', 'Địa chỉ rút tiền', 'Vui lòng nhập nội dung', 'nhận xét', 'danh sách địa chỉ'],
    address_btn: ['Thêm', 'Lưu', 'Xóa', 'Chỉnh sửa'],
    address_td: ['Tiền tệ', 'Địa chỉ rút tiền', 'Chú thích', 'Vận hành'],
    currency_td: ['Tiền tệ', 'Khả dụng', 'Đóng băng', 'Chuyển đổi'],

    table_title: 'Tổng tài sản：',
    table_address_title: 'Quản lý địa chỉ rút tiền',
    table_td: ['Tiền tệ', 'Khả dụng', 'Đóng băng', 'Chuyển đổi', 'Vận hành'],
    table_btn: ['Tiền ký quỹ', 'Rút tiền', 'ghi âm', 'chuyển khoản'],

    money_text: ['Địa chỉ rút tiền', 'xin vui lòng chọn', 'Số lượng', 'Khả dụng：', 'Phí',
      'Số tiền đến', 'Mật khẩu giao dịch','Thẻ (Ghi nhớ)','Tối thiểu '],
    money_btn: 'Rút tiền',
    xzbz: 'Lựa chọn tiền tệ',
    money_msg: ['Lời nhắc', '1. Thời gian rút tiền là 12: 00-24: 00 giờ Hồng Kông, với 2 đơn rút tiền mỗi ngày (rút tối thiểu 100u, rút ​​tối đa 200.000u);', '2. Hiện tại, rút ​​tiền chỉ được hỗ trợ bằng tiền USDT, Loại liên kết ví chọn ERC20; ',' 3. Sau khi gửi đơn xin rút tiền, tiền sẽ bị đóng băng do quá trình rút tiền đang diễn ra và tiền tạm thời được quản lý bởi hệ thống và bạn không thể tự do kiểm soát. Nó không có nghĩa là bạn đã mất tài sản hoặc tài sản bất thường. Vui lòng kiên nhẫn chờ phê duyệt; ',' 4. Thời gian đến sau khi gửi đơn rút tiền tùy thuộc vào thời gian xác nhận của khối. Nếu không dự kiến ​​rút tiền sau thời gian rút tiền, vui lòng liên hệ với bộ phận chăm sóc khách hàng để được giải đáp; ',' 5. Để ngăn chặn Thiết lập hành vi hiện tại, 90% tổng số tiền tiêu dùng được yêu cầu để bắt đầu rút tiền '],

    recharge_title: 'Địa chỉ nạp tiền',
    recharge_btn: ['Sao chép', 'Mã QR', 'Tiền ký quỹ'],
    recharge_text: ['Số lượng', 'Lời nhắc', 'Không nạp tiền cho bất kỳ tài sản không phải USDT nào vào địa chỉ trên, nếu không tài sản sẽ không được truy xuất. ',' Tiền gửi USDT chỉ hỗ trợ phương thức gửi đơn giản, tiền gửi sử dụng các phương thức khác (gửi tất cả) tạm thời không thể được đăng, xin vui lòng hiểu. ','Thông tin đăng nhập', 'diễn tả(Không bắt buộc)','Tên chuỗi'],

    record_title: 'Các báo cáo tài chính',
    record_td: ['Số lượng', 'ghi âm', 'Thời gian'],

    transfer_title: 'chuyển khoản',
    transfer_btn: ['Tất cả', 'chuyển giao'],
    transfer_text: ['Từ', 'đến', 'Vui lòng nhập số tiền chuyển', 'Khả dụng：'],
    "bq": "Thẻ (Ghi nhớ)",
    "qsrbq": "Vui lòng nhập thẻ",
    "yhktx": "Rút qua thẻ ngân hàng",
    "yhmc": "Tên ngân hàng",
    "qsryhmc": "Vui lòng nhập tên ngân hàng",
    "yhzh": "Tài khoản ngân hàng",
    "qsryhzh": "Vui lòng nhập số tài khoản ngân hàng",
    "gjhkdm": "Mã SWIFT",
    "qsrgjhkdm": "Vui lòng nhập mã SWIFT",
    "yhdz": "Địa chỉ ngân hàng",
    "qsryhdz": "Vui lòng nhập địa chỉ ngân hàng",
    "skrxm": "Tên người hưởng",
    "qsrskrxm": "Vui lòng nhập tên người hưởng",
    "skrdh": "Số điện thoại của người hưởng",
    "qsrskrdh": "Vui lòng nhập số điện thoại của người hưởng",
    "skrdz": "Địa chỉ của người hưởng",
    "qsrskrdz": "Vui lòng nhập địa chỉ của người hưởng"
  },
  text: {
    btn: 'return',
    login: 'Vui lòng đăng nhập trước'
  },
  deal: {
    chooseType: 'Loại hoa hồng',
    choose: 'xin vui lòng chọn',
    balance: 'Số dư：',
    account: ['Tài khoản', 'Có sẵn', '/ Đóng băng', 'Chuyển khoản'],
    dir: ['Mua', 'Bán'],
    dir2: ['Khả dụng', 'Có thể mua bán'],
    cs: 'Tùy chọn',
    sxf: 'Tỷ lệ phí',
    jye: 'Giao dịch',
    sc_list: ['Thị trường', 'cặp tiền', 'giá tăng'],
    sc_h: ['Latest', '24H Lowest', '24H Highest', '24H Vol.'],
    td_lt: ['tiền tệ', 'giá mới nhất', 'giá đã tăng'],
    k_line_txt: ['≈', '', 'Tăng', 'Giá cao nhất', 'Giá thấp nhất', 'Khối lượng 24 giờ'],
    tabListLTitle: ["Lệnh mở", "Hoa hồng lịch sử"],
    tabListLEntrust: ["Mua", "Bán"],
    tabListRTitle: ["Hạn chế giao dịch", "Giao dịch thị trường"],
    table_btn: ['Hủy lệnh'],
    index_td_l: ['Thời gian', 'Đối tượng giao dịch', 'Số lượng', 'Giá', 'Hoạt động'],
    index_td_r: ['Giá mới nhất', 'hướng đi', 'Giá', 'số lượng'],
    index_td_r2: ['Giao dịch mới nhất', 'Thời gian', 'Giá', 'Khối lượng giao dịch'],
    table_txt: ['Đã hoàn tất', 'Đã hủy lệnh'],

    db_1_txt: ["Có sẵn", "Giá mua", "Giá bán", "Khối lượng mua", "Khối lượng bán", "Khối lượng giao dịch", "Mua với giá tốt nhất thị trường", "Giá tốt nhất thị trường để bán ",' mua tay ',' bán tay '],
    db_2_txt: ['Giá', 'đòn bẩy', 'vui lòng chọn', 'lô', 'một lô bằng', 'lô', 'giá trị thị trường hợp đồng', 'ký quỹ', 'mua với giá thị trường tốt nhất', ' tại thị trường Bán giá tốt nhất '],
    pathList: ['Bản ghi hợp đồng', 'Bản ghi giao dịch'],
    db_btn: ['Mua (mua lâu dài)', 'Bán (bán khống)'],
    tabListLTitle2: ['Lệnh mở'],

    lt_btn: ['Thanh khoản một lần nhấp chuột', 'Đặt mức dừng lãi và giá cắt lỗ', 'Đóng', 'Xác nhận ngay bây giờ', 'trở về'],
    lt_txt: ['Tỷ lệ rủi ro:', 'Tổng lãi và lỗ của vị thế:'],
    lt_td: ['Loại', 'Đòn bẩy nhiều', 'Giá vị thế', 'Giá hiện tại', 'Ký quỹ', 'Giá chốt lời', 'Giá cắt lỗ', 'Thời gian mở', 'Số lô', ' Lãi và lỗ ',' Hoạt động '],
    lt_dl: ['Set the Stop Loss and price cắt lỗ', 'Chốt lời', 'Giá cắt lỗ'],

    lt_0_btn: ['Hủy lệnh'],
    lt_0_td: ['Thông tin liên hệ', 'Đơn vị tiền tệ', 'Số lượng', 'Giá hiện tại', 'Phí xử lý', 'Vận hành'],

    lt_1_btn: ['Đóng'],
    lt_1_txt: ['Đang đóng'],
    lt_1_td: ['Loại', 'Giá vị thế', 'Giá hiện tại', 'Ký quỹ', 'Giá chốt lời', 'Giá cắt lỗ', 'Thời gian mở cửa', 'Phí xử lý', 'Lãi lỗ', 'Hoạt động'],
    node_data: 'Không có dữ liệu',

    lt_3_txt: ['Đã đóng', 'Thanh toán'],
    lt_3_td: ['Loại', 'Lô', 'Giá vị thế', 'Giá đóng cửa', 'Giá chốt lời', 'Giá cắt lỗ', 'Ký quỹ', 'Ký quỹ khả dụng', 'Thời gian mở cửa', 'Thời gian đóng cửa', ' Phí xử lý ','Lãi và lỗ', 'hoạt động'],

    lt_4_txt: ['Đã hủy lệnh'],
    cm: ['Thời gian công bố', 'Mã số phát hành', '流通总量', '总凑价格', 'Trang web chính thức','Sách trắng','介绍'],
    qsrsl: 'Vui lòng nhập số tiền',
    qsrss: 'Vui lòng nhập lô',
  },
  notice:{
      notice_title:'Trung tâm thông báo',
  },
  bzhl:{
    title: 'Đầu tư AI',
    title1: 'Định lượng AI',
    ttzbt: '天天赚不停',
    wdtg: 'Lưu trữ của tôi',
    zztgdzj: 'Quỹ giám hộ',
    yjjrsy: 'Ước tính hàng ngày',
    ljsy: 'Tổng doanh thu',
    tgzdd: 'Lệnh giám hộ',
    tgdd: 'Lệnh ký quỹ',
    t1: 'Rủi ro thấp và quản lý tài chính ổn định, có thể đổi trả bất kỳ lúc nào nếu cần',
    t2: 'Trợ lý quản lý tiền miễn phí của bạn',
    cljxcp: 'Chu kỳ sản phẩm',
    dbxe: 'Hạn mức đơn',
    rsyl: 'Lợi suất hàng ngày(%)',
    rsyl2: 'Lợi suất hàng ngày：',
    zq: 'Chu kỳ',
    qmr: 'Đi mua',
    ckgd: '더보기',
    cpgk: 'Tổng quan về sản phẩm',
    pxsj: 'Thời gian thanh toán cổ tức',
    tgzj: 'Vốn chủ sở hữu giám hộ',
    tqsh: 'Sự chuộc lỗi sớm',
    cpld: 'Những điểm nổi bật của sản phẩm',
    cpgz: 'Quy tắc sản phẩm',
    cont: 'Di chuyển gạch là bằng cách lưu trữ USDT trên nền tảng và đội ngũ chuyên nghiệp của nền tảng có quyền di chuyển gạch. Người tham gia có thể nhận được phần thu nhập từ chuyển gạch của nền tảng trong thời gian lưu ký quỹ. Có thể truy cập vào bất kỳ lúc nào. là an toàn và thuận tiện.',
    zj: 'Tài trợ 100%',
    aqbz: 'Bảo mật',
    jjrsy: 'Thu nhập vào ngày nghỉ lễ',
    bjd: 'Không gián đoạn',
    cgcrh: 'Sau khi ký quỹ thành công',
    dtqx: 'Giá trị lãi suất theo ngày',
    ljzr: 'Chuyển ngay',
    xqglgj: 'Các công cụ quản lý tiền miễn phí',
    ddh: 'Mã số lệnh',
    tgje: 'Số tiền giám hộ',
    tgsj: 'Chu kỳ ngày',
    yhl: 'Đã có lãi',
    xdsj: 'Thời gian đặt lệnh',
    zt: 'trạng thái',
    fh: 'trở về',
    qrnhsy: '七日年化收益',
    ygy: '1个月',
    bn: '半年',
    yn: '1年',
    yuan: '元',
    tzfx: 'rủi ro đầu tư',
    shsc: 'Thời gian đổi thưởng',
    di: 'Thấp',
    yggzr: 'Một ngày làm việc',
    msgsxf: 'Phí đăng ký miễn phí',
    mr: 'Hàng ngày',
    dqfh: 'Hoàn trả khi đến hạn',
    ljgm: 'Mua ngay',
    tgz: 'Giám hộ',
    sh: 'Đổi',
    ywc: 'Đã hoàn tất',
    ysh: 'Đã đổi',
    all: 'Tất cả',
    "xzbzts": "Đơn giản và an toàn. Cổ tức có thể được chọn bằng nhiều loại tiền tệ",
    "qtbz": "Các loại tiền khác"
  },
  pay:{
    qsrjymm: 'Vui lòng nhập mật khẩu giao dịch gồm 6 chữ số',
    tbmmts: 'Vui lòng đến trung tâm người dùng để đặt mật khẩu giao dịch',
  },
  tips:{
    qxztbdz: 'Vui lòng nhập địa chỉ rút tiền',
    qsrtbsl: 'Vui lòng nhập số lượng của tiền tệ sẽ rút'
  },
  statusText: ['Không thành công', 'Đang chờ xử lý', 'Thành công'],
  dzrz: {
    title: 'Xác thực địa chỉ',
    sdddz: 'Địa chỉ hóa đơn tiện ích',
    zdtpsc: 'Tải lên ảnh hóa đơn',
    qsrsdddz: 'Bạn cần điền thông tin địa chỉ và gửi hóa đơn điện nước hoặc hóa đơn địa chỉ băng thông rộng',
    qsczdtp: 'Vui lòng tải lên hình ảnh của hóa đơn',
    status: ['đang xem xét', 'đánh giá đã thông qua'],
    qd: 'Được',
  },
  jgcc: {
    wtgd: 'Lệnh đang chờ',
    cj: 'Thỏa thuận',
    jj: 'Thông tin',
    zc: 'Hiện thời',
    lszc: 'Lịch sử',
    qblx: 'Tất cả các loại',
    xj: 'Giá hiện thời',
    sj: 'Thời gian',
    fx: 'Xu hướng',
    jg: 'Giá',
    sl: 'Số lượng',
    jgsj: 'Thời gian giao',
    gmj: 'Giá mua',
    jsj: 'Giá thanh toán',
    yk: 'Lãi và lỗ',
    xq: 'Chi tiết',
    "mz": "Tăng giá",
    "md": "Giảm giá",
    dqye: 'Số dư hiện thời',
    gb: 'Đóng',
    jxxd: 'Tiếp tục đặt lệnh',
    qrxd: 'Xác nhận',
    ddqr: 'Xác nhận lệnh',
    sxf: 'Phí',
    kyye: 'Thăng bằng',
    jypz: 'Cặp',
    jyfx: 'Xu hướng',
    tzje: 'Mức giá đầu tư',
    tzjeTips: 'Số tiền đầu tư không được bằng 0',
    dqsj: 'Thời gian hết hạn',
    jssj: 'Thời gian giao',
    gmsj: 'Thời gian mua hàng',
    sy: 'Lãi',
    zxje: 'Số tiền tối thiểu ',
    shi: 'H',
    fen: 'M',
    miao: 's',
    zdje: 'Số tiền tối đa ',
    qsrje: 'Vui lòng nhập số tiền',
    zxtzje: 'Tối thiểu ',
    yebz: 'Thiếu cân bằng',
    xq: 'Chi tiết',
    ddz: 'Đang chờ đợi',
    jgjl: 'Biên bản giao hàng',
    bz: 'Tiền tệ',
    cz: 'Vận hành'
  },
  kjmb: {
    title: 'Mua Tiền mật mã',
    fzcg: 'Sao chép thành công',
    ljmb: 'Mua Tiền mật mã',
    lxkf: 'liên hệ với dịch vụ khách hàng'
  },
  news: {
    title: 'Tin nhắn của tôi',
    "gg": "Thông báo",
    ckxq: 'Xem chi tiết'
  },
  statusTabs:['Danh sách hàng chờ', 'Đang giao dịch','Đã đóng', 'Đã rút'],
  "chongzhi":{
    "zy": "Quan trọng",
    "cbxx": "Thông tin tiền gửi mã thông báo",
    "qsrsl": "Vui lòng nhập số tiền gửi",
    "tips2": "1. Khả năng tương thích của ví / nền tảng: nghĩa là mạng được hỗ trợ; nếu nền tảng đích không hỗ trợ mạng rút tiền của bạn, thì không thể truy xuất tài sản.",
    "tips3": "2. Mạng nạp tiền của bạn và nền tảng mục tiêu giống nhau; nếu bạn chọn địa chỉ mục tiêu là mạng Ethereum, nhưng người nạp tiền chọn chuỗi thông minh TRC20, bạn có thể không truy xuất được tài sản kỹ thuật số của mình.",
    "tips4": "3. Đảm bảo rằng địa chỉ và số tiền của bạn là chính xác trước khi nạp tiền.",
    "tips5": "Nhắc nhở: Do tính ẩn danh và tính riêng tư của mạng khối, một khi bạn nhập sai thông tin, bạn sẽ mất tài sản tương ứng. Vui lòng kiểm tra kỹ địa chỉ và số lượng nạp tiền của bạn",
    "tips2_1": "• Vui lòng không tính phí bất kỳ tài sản không phải nội tệ nào cho địa chỉ trên, nếu không, không thể truy xuất tài sản.",
    "tips2_2": "• Không thể giao tiền kỹ thuật số đúng lúc. Thời gian đến thực tế phụ thuộc vào tốc độ xác nhận của blockchain.",
    "tips2_3": "• Địa chỉ nạp tiền của bạn sẽ không thay đổi thường xuyên, bạn có thể nạp tiền; nếu có bất kỳ thay đổi nào, chúng tôi sẽ cố gắng hết sức để thông báo cho bạn qua email hoặc thông báo trên trang web.",
  },
  "tibi": {
    "tbxx": "Thông tin Rút tiền",
    "qsrbq": "Vui lòng nhập nhãn",
    "tbTips1": "• Để đảm bảo an toàn cho nguồn tiền, khi chính sách bảo mật tài khoản của bạn thay đổi, thay đổi mật khẩu, chúng tôi sẽ xem xét thủ công việc rút tiền, hãy kiên nhẫn chờ nhân viên liên hệ với bạn qua điện thoại hoặc email.",
    "tbTips2": "• Hãy đảm bảo rằng máy tính và trình duyệt của bạn an toàn để ngăn thông tin bị giả mạo hoặc bị rò rỉ.",
    "tbTips3": "• Tài sản kỹ thuật số mà bạn đề cập là tài sản đa chuỗi một xu. Bất kể bạn chọn huy động từ chuỗi nào, điều đó có nghĩa là tổng số tài sản kỹ thuật số hiển thị trên trang rút tiền mà bạn sở hữu sẽ bị giảm bằng số tiền tương ứng đã huy động được. ",
  },
  "gjlb": "Danh sách các quốc gia",
  "qxzgjlb": "Vui lòng chọn Quốc gia / Vùng",
  "mbwt":{
    "title": "Vấn đề An ninh",
    "mbwt": "Vấn đề An ninh",
    "problem":[
      {
        "id": 1,
        "title": "Ai là người bạn thân nhất của bạn?"
      },
      {
        "id": 2,
        "title": "Thần tượng của bạn là ai?"
      },
      {
        "id": 3,
        "title": "Nơi khao khát nhất của bạn là ở đâu?"
      }
    ],
    "qtxda": "Vui lòng trả lời",
    "qsrxmm": "Vui lòng nhập mật khẩu mới",
    "qqrmm": "Vui lòng xác nhận mật khẩu của bạn",
    "sydqmmcz": "Sử dụng Đặt lại Mật khẩu Hiện tại",
    "zhmm": "Vấn đề bảo mật Lấy lại mật khẩu",
    "ysz": "Cài đặt",
    "tg": "Bỏ qua",
    "tj": "Gửi đi",
    "zyts": "Quan trọng:",
    "zytsCont": "Không tiết lộ câu trả lời bí mật và mã xác minh, đồng thời lưu ý vấn đề bảo mật, điều này sẽ giúp bạn lấy lại mật khẩu của mình"
  },
  "zc":{
    "zclb": "Danh sách tài sản",
    "zczh": "Chuyển đổi tài sản",
    "yczc": "Ẩn tài sản bạn không có"
  },
  "indexNew":{
    "t1": "Hàng đầu Toàn cầu",
    "t2": "Nền tảng Dịch vụ Tài sản Kỹ thuật số",
    "t3": "Hoàn thành giao dịch tài sản kỹ thuật số blockchain một cửa",
    "t4": "Số điện thoại di động / Email",
    "t5": "Đăng ký ngay",
    "t6": "Chào mừng khách hàng từ khắp nơi trên thế giới thông qua MFTG",
    "t7": "Khám phá và bắt đầu hành trình mã hóa của chúng"
  },
  "newReg":{
    "dl": ['e-mail','Di động'],
    "cjzh": "Tạo tài khoản",
    "sysjhzyx": "Đăng ký bằng số điện thoại di động / email",
    "yhxy": "&lt;Thoản thuận người dung&gt;",
    "yhxy2": "Tôi đã đọc và đồng ý với &lt;Thoản thuận người dung&gt;",
    "yxgz": "Vui lòng nhập email hợp lệ",
    "dhgz": "Số điện thoại di động không chính xác"
  },
  "indexNew2": {
    "t1": "Giao dịch theo lệnh của chúng tôi",
    "t2": "Sử dụng Bitbank",
    "t3": "Bitbank là một sàn giao dịch trao đổi bitcoin và tài sản mã hóa được thiết kế khéo léo. Nó rất đơn giản, thuận tiện, an toàn và mạnh mẽ. Nó hỗ trợ giao dịch trên nhiều nền tảng web và điện thoại thông minh. Dữ liệu và biểu đồ giao dịch được cập nhật theo thời gian thực. Toàn diện phân tích giá thị trường cung cấp hơn 60 công cụ phân tích kỹ thuật. Hãy bắt đầu giao dịch ",
    "ksjy": "Bắt đầu giao dịch",
    "ly": "5 lý do để chọn Bitbank",
    "item1_t1": "Khối lượng giao dịch hàng đầu",
    "item1_t2": "Khối lượng giao dịch tài sản tiền điện tử số 1 *",
    "item1_t3": "Tính thanh khoản cao, giao dịch thoải mái (trải nghiệm giao dịch dễ chịu). Liệt kê 12 loại tài sản tiền điện tử.",
    "item2_t1": "Đánh giá cao của bên thứ ba",
    "item2_t2": "Môi trường giao dịch an toàn",
    "item2_t3": "Sử dụng ví lạnh ngoại tuyến. Sử dụng Multisig để ngăn chặn tin tặc. Bảo vệ tài sản của bạn bằng công nghệ cao",
    "item3_t1": "Ứng dụng dễ sử dụng và đáng tin cậy",
    "item3_t2": "Ứng dụng dễ sử dụng và đơn giản",
    "item3_t3": "Một ứng dụng đáng tin cậy với các chức năng phong phú. Nó có thể duy trì các cơ hội giao dịch bên ngoài giao dịch.",
    "item4_t1": "Mở cửa cả ngày",
    "item4_t2": "Có thể gửi vàng",
    "item4_t3": "Hỗ trợ tiền gửi 24 giờ, kể cả ngày lễ!",
    "item5_t1": "Điện thoại thông minh và PC",
    "item5_t2": "Thiết kế nhân bản",
    "item5_t3": "Ngay cả khi bạn sử dụng điện thoại thông minh, bạn có thể thực hiện các giao dịch đơn giản và đủ điều kiện mà không do dự",
    "aqkk": "An toàn và đáng tin cậy",
    "aqkk2": "Giao dịch Bitcoin Bitbank",
    "cjzh": "Tạo tài khoản",
  },
  "xbsg":{
    "title": "Khu vực tiền xu mới",
    "wdsg": "Thông tin chi tiết",
    "scts": "Ngày nhốt: ",
    "sy": "còn lại",
    "ljsg": "Theo dõi ngay",
    "ysk": "Bán hết",
    "xzjdy": "Theo dõi ngay",
    "dy": "Đặt mua",
    "fxjg": "giá phát hành",
    "fxl": "Vòng tuần hoàn",
    "ssrq": "Ngày niêm yết",
    "yxqx": "Thời gian hiệu lực",
    "qsrsl": "Vui lòng nhập số tiền",
    "syl": "còn lại",
    "sgrq": "đặt mua",
    "sgsl": "Số lượng",
    "bz": "Đồng tiền",
    "yebz": "Số dư USDT không đủ",
    "tgsl": "Vượt qua Qty",
    "shz": "đang xem xét",
    "wtg": "Không vượt qua",
    "ytg": "thông qua"
  },
  "wydb":{
    "title": "Vay",
    "db": "Vay",
    "dbz": "Vay",
    "jl": "Hồ sơ cho vay",
    "jdzq": "vay (ngày)",
    "qhk": "Trả lại",
    "ljdb": "Tích lũy (usd)",
    "dhkbs" :"Trả nợ",
    "jkje": "số tiền (usdt)",
    "qsrje": "Vui lòng nhập số tiền",
    "rll": "Lãi suất hàng ngày",
    "hkfs": "Trả nợ",
    "dqych": "Hết hạn",
    "lx": "Quan tâm",
    "fkjg": "Người cho vay",
    "tpsc": "Khoản vay tín dụng (tải lên hình ảnh)",
    "fwxx": "Thông tin nhà ở",
    "srzm": "Chứng minh thu nhập (mối quan hệ việc làm)",
    "yhmx": "Sao kê ngân hàng",
    "zjz": "Ảnh ID",
    "yd": "Tôi đã đọc và đồng ý",
    "xy": "Đăng ký hợp đồng vay",
    "sqdb": "Nộp đơn xin vay",
    "gb": "Khép kín",
    "qd": "VÂNG",
    "ts": "Vui lòng kiểm tra Đăng ký hợp đồng vay",
    "dbjl": "ghi lại",
    "hkhth": "Mã đặt hàng",
    "wsh": "Chưa được đánh giá",
    "yfk": "Tiền vay",
    "sqrq": "thời gian nộp đơn",
    "zq": "xe đạp",
    "dbsl": "số lượng",
    "zhke": "Tổng tiền thanh toán",
    "yhke":"Số tiền đã trả",
    "yhkxq": "Chi tiết trả nợ",
    "bqyhk": "Phải trả trong kỳ hiện tại(USDT)",
    "hktips": "Hãy đảm bảo số dư còn đủ, nếu số dư không đủ vui lòng nạp tiền trước rồi hoàn trả",
    "bj": "Hiệu trưởng",
    "jie": "Vay",
    "ljhk": "Trả nợ ngay lập tức",
    "qcz": "Gửi tiền",
    "yebzqxcz": "Không đủ số dư, vui lòng nạp tiền trước và sau đó hoàn trả",
    "znj": "phí thanh toán chậm",
    "yqts": "Ngày quá hạn"
  },
  "hkxq":{
    "dd":"Gọi món",
    "fzhkdz":"Sao chép địa chỉ trả nợ",
    "hkxq": "Chi tiết trả nợ",
    "zlx": "tổng lãi",
    "zhk": "tổng số tiền hoàn trả",
    "hkjg": "cơ quan trả nợ",
    "qschkpz": "Vui lòng tải lên chứng chỉ hoàn trả",
    "hkpz": "giấy chứng nhận trả nợ"
  },
  "bbjyNew":{
    "jylx": "Các loại",
    "jyze": "Số lượng"
  },
  "bind":{
    "title": "email",
    "ybd": "Ràng buộc",
    "wbd": "Không ràng buộc",
    "ts": "Để bảo vệ tài khoản của bạn, bạn nên liên kết một địa chỉ email",
    "qsryxdz": "Vui lòng nhập địa chỉ email của bạn"
  },
  "tipsNew": {
    "yjj": "từ chối",
    "shz": "chuộc lỗi"
  },
  "newIndex2": {
    "zxhy": "Báo giá Mới nhất",
    "jypt": "Nền tảng giao dịch",
    "ssyc": "Thu hẹp Ẩn",
    "hwzc": "Bạn chưa đăng ký?",
    "ljzc": "Đăng ký ngay bây giờ và khám phá rất nhiều cơ hội!",
    "yyzh": "Đã có tài khoản?",
    "hjbj": "Đăng nhập nếu bạn có tài khoản, lâu rồi không gặp!",
    "lmdh": "Điều hướng Cột",
    "ghdjy": "Thỏa thuận tốt hơn, cuộc sống tốt hơn",
    "ghdjy02": "Trung tâm giao dịch tiền điện tử sáng tạo nhất thế giới ở đây, nơi bạn có thể mua, giao dịch và kiếm tiền điện tử với hàng trăm loại tiền điện tử trong tầm tay của bạn.",
    "indexCont01": "Luôn bên cạnh bạn",
    "indexCont02": "Giao dịch thị trường giao ngay và thị trường ký quỹ của chúng tôi với các tùy chọn cấp vốn nâng cao, khớp lệnh nhanh như chớp và thanh khoản sâu.",
    "indexCont03": "API mạnh mẽ",
    "indexCont04": "Dễ dàng quản lý các vị trí của bạn với API trực quan, nền tảng giao dịch và các tùy chọn đặt hàng nâng cao của chúng tôi.",
    "indexCont05": "Nội dung kỹ thuật số chất lượng cao",
    "indexCont06": "9 năm 0 tai nạn",
    "indexCont07": "Kiểm soát Rủi ro Bảo mật Hàng đầu",
    "indexCont08": "Đòn bẩy lên đến 25 lần",
    "indexCont09": "Giao dịch CFD Bitcoin với đòn bẩy gấp 25 lần.",
    "indexCont010": "Dự trữ an toàn",
    "indexCont011": "Thanh khoản sâu",
    "indexCont012": "Công nghệ đặt hàng đa thị trường độc quyền tiên tiến của chúng tôi giúp tăng cường tính thanh khoản, thắt chặt chênh lệch và giảm trượt giá.",
    "indexCont013": "Sở thích người dùng",
    "indexCont014": "Quốc gia được Bảo hiểm",
    "indexCont015": "Điểm mạnh của chúng tôi",
    "indexCont016": "Giao dịch thị trường giao ngay và thị trường ký quỹ của chúng tôi với các tùy chọn cấp vốn nâng cao, khớp lệnh nhanh như chớp và thanh khoản sâu.",
    "indexCont017": "Lưu trữ An toàn",
    "indexCont018": "Chúng tôi sử dụng kết hợp ví lạnh và công nghệ tính toán đa bên (MPC) để quản lý tài sản kỹ thuật số.",
    "indexCont019": "An toàn trên hết",
    "indexCont020": "Chúng tôi sử dụng công nghệ mới nhất để giữ an toàn cho tiền của bạn và luôn vượt qua các lỗi và các nỗ lực khai thác.",
    "indexCont021": "Rút tiền nhanh",
    "indexCont022": "Sử dụng tính toán của nhiều bên, chúng tôi có thể cung cấp dịch vụ rút tiền nhanh 24/7 trong khi vẫn duy trì các tiêu chuẩn bảo mật nghiêm ngặt của chúng tôi.",
    "indexCont023": "Mua, Bán tiền điện tử",
    "indexCont024": "Tham gia nền tảng giao dịch an toàn và toàn diện nhất thế giới",
    "indexCont025": "Mua và bán Bitcoin, Ethereum, XRP và nhiều loại tiền điện tử khác bằng fiat hoặc tiền điện tử.",
    "yqwj": "10 triệu +",
    "dlzc": "Đăng nhập để đăng ký",
    "yzm": "Mã xác minh",
    "qrmm": "Xác nhận mật khẩu"
  },
  "langNew2":{
    "flzq": "Trung tâm phần thưởng",
    "qdjl": "Đăng nhập phần thưởng",
    "mrqdjl": "Phần thưởng đăng nhập hàng ngày",
    "qd": "Đăng nhập",
    "yqd": "Đăng nhập",
    "hdgz": "Thể lệ sự kiện",
    "qdjl2": "Nhật ký nhập cảnh",
    "qdcg": "Đăng nhập thành công",
    "yhd": "Đã nhận được",
    "lq": "Nhận",
    "dyt": "Ngày 1",
    "det": "Ngày 2",
    "dst": "Ngày 3",
    "dsit": "Ngày 4",
    "dwt": "Ngày 5",
    "dlt": "Ngày 6",
    "dqt": "Ngày 7",
    "jxz": "đang tiến hành",
    "cjxnzh": "Tạo tài khoản ảo",
    "sy":"Trang chủ",
    "sc":"Chợ",
    "sclb":"Danh sách thị trường",
    "jy":"Buôn bán",
    "zh":"Tài khoản",
    "db":"Khoản vay",
    "zchm":"Số đăng ký",
    "cp":"Sản phẩm",
    "tzjd":"Cho vay đầu tư",
    "zxzc":"Hỗ trợ trực tuyến",
    "xd":"Đặt hàng",
    "zzjptgmnr":"Đầu tư vào tương lai của bạn. Phát triển danh mục đầu tư của bạn trong một hệ thống tài chính công bằng và cởi mở.",
    "yy":"Ứng dụng",
    "pqnr":"Ngân hàng di động phá vỡ các quy tắc truyền thống và cung cấp cho bạn các công cụ quản lý tài chính chính xác.",
    "jiami":"Tiền điện tử",
    "tgnr":"Bằng cách gửi tiền bằng tiền điện tử, bạn có thêm một lớp bảo mật và đảm bảo xử lý giao dịch nhanh chóng.",
    "jyl":"Khối lượng giao dịch 24h",
    "ssjmhb":"Danh sách tiền điện tử",
    "zchy":"Người dùng đã đăng ký",
    "djxz":"Bấm chuột để tải xuống",
    "azsc":"Chợ Android",
    "pgsd":"Cửa hàng táo",
    "bqxx":'©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
  },
  // "langNew":{
  //   "szhb": "tiền điện tử",
  //   "gjs": "Kim loại",
  //   "yy": "thô",
  //   "jy": "Buôn bán",
  //   "jmhb": "tiền điện tử",
  //   "yxhy": "Hợp đồng vĩnh viễn",
  //   "gdjy": "danh sách hàng chờ",
  //   "khh": "Tài khoản đang mở",
  //   "qsrkhh": "Vui lòng nhập ngân hàng",
  //   "yhkh": "Tài khoản ngân hàng",
  //   "qsryhkh": "Vui lòng nhập số tài khoản ngân hàng",
  //  },
   "login":{
     login: 'Vui lòng đăng nhập',
     msg: 'Vui lòng nhập tài khoản đã đăng ký của bạn',
     list: ['Di động / Email', 'Mật khẩu', 'Quên mật khẩu?', 'Đăng nhập', 'Không có tài khoản, đăng ký ngay'],
     message: 'Tài khoản hoặc mật khẩu không được để trống',
     "cdlks":"Hãy bắt đầu với việc đăng nhập!",
     "zh":"Tài khoản",
     "qsrzh":"Nhập tên người dùng của bạn",
     "mm":"Mật khẩu",
     "qsrmm":"Nhập mật khẩu",
     "dl":"Đăng nhập",
     "wjmm":"Quên mật khẩu",
     "qbdl":"Đăng nhập bằng Ví",
     "myzh":"Tôi không có tài khoản?",
     "zc":"Đăng ký",
     "yzm":"Mã xác nhận",
     "qsryzm":"Nhập mã xác nhận",
     "hqyzm":"Mã đã gửi",
     "qrmm":"Xác nhận mật khẩu",
     "qsrqrmm":"Xác nhận mật khẩu",
     "lcmmbyz":"Hai lần nhập mật khẩu không nhất quán",
     "mmts":"Độ dài mật khẩu 6-12 ký tự",
     "sjtx":"Lỗi định dạng số điện thoại",
     "yxts":"Lỗi định dạng email",
     "qr":"ĐƯỢC RỒI",
     "sjzc":"Điện thoại di động",
     "sjh":"Số điện thoại",
     "qsrsjh":"Nhập số điện thoại",
     "yqm":"Mã lời mời (tùy chọn)",
     "qsryqm":"Nhập mã mời",
     "yxzc":"E-mail",
     "wyydbzx":"Đồng ý",
     "yhxy":"<Thỏa thuận dịch vụ người dùng>",
     "yhxy2":"Thỏa thuận dịch vụ người dùng",
     "ysyx":"<Thỏa thuận bảo vệ quyền riêng tư>",
     "yx":"E-mail",
     "qsryx":"Nhập email",
     "yxgsbzc":"Email không hợp lệ",
     "cjmnzhcg":"Tài khoản demo được tạo thành công",
     "tcmnzh":"Thoát khỏi tài khoản demo",
     "qbdlts":"Vui lòng sử dụng ví DAPP Đăng nhập",
   },
   // "index":{
   //   "xgnysx":"Các tính năng mới đang trực tuyến!",
   //   "hyld":"Chào mừng bạn đến với nền tảng giao dịch tài chính từng đoạt giải thưởng của chúng tôi và khám phá thế giới tài chính tương lai với các nhà đầu tư toàn cầu",
   //   "symncz":"Sử dụng tài khoản demo",
   //   "zdjyfy":"Phí giao dịch tối thiểu <0,3%",
   //   "jysyzc":"Giao dịch tất cả tài sản của bạn ở một nơi",
   //   "hbsp":"Forex, Tiền điện tử, Cổ phiếu, Chỉ số, Hàng hóa",
   //   "ksjy":"Bắt đầu",
   //   "jdewd":"Đơn giản và ổn định",
   //   "aizb":"Giao dịch AI vàng",
   //   "srjh":"Tạo kế hoạch thu nhập của bạn chỉ bằng một cú nhấp chuột",
   //   "kssy":"Bắt đầu sử dụng",
   //   "dlyhggdje":"Lãi suất thấp và số tiền cao hơn",
   //   "jmhbdk":"Cho vay tiền điện tử",
   //   "zmyrhdyp":"Vay tiền điện tử giao ngay mà không cần bất kỳ tài sản thế chấp nào",
   //   "gs":"Công ty",
   //   "gywm":"Về chúng tôi",
   //   "xkzjd":"Giám sát giấy phép",
   //   "bzzx":"Trung tâm trợ giúp",
   //   "zhengce":"Chính sách",
   //   "tkytj":"Các điều khoản và điều kiện",
   //   "yszc":"Chính sách bảo mật",
   //   "sm":"Tuyên bố",
   //   "flxx":"Thông tin hợp pháp",
   //   "mzsm":"Tuyên bố miễn trừ trách nhiệm",
   //   "fxjg":"Cảnh báo rủi ro",
   //   "gygg":"Về quảng cáo",
   //   "gg":"Thông báo",
   // },
   "hq":{
     "wh":"Ngoại hối",
     "szhb":"tiền điện tử",
     "gp":"Cổ phần",
     "zs":"Mục lục",
     "eft":"ETF",
     "mc":"Tên",
     "xs":"24h%",
     "tb":"Đồ thị",
     "jg":"Giá",
   },
   "user":{
     "wdzh":"Tài khoản của tôi",
     "zh":"Tài khoản: ",
     "dk":"Khoản vay: ",
     "sydbzj":"Ký quỹ được sử dụng: ",
     "yqll":"Lợi nhuận kì vọng: ",
     "qtgn":"Cac chưc năng khac",
     "cz":"Tiền gửi",
     "tx":"Rút",
     "dh":"Trao đổi",
     "zhyz":"Chứng nhận KYC",
     "zhjl":"Lịch sử tài khoản",
     "yqhy":"Mời bạn bè",
     "flzq":"Khu phúc lợi",
     "ggmm":"Đổi mật khẩu",
     "sz":"Cài đặt",
     "cjwtjd":"Câu hỏi thường gặp",
     "fzdz":"Sao chép địa chỉ",
     "sl":"Số lượng...",
     "qsrsl":"Nhập số lượng",
     "dd":"Nhận (USDT): ",
     "sczm":"Tải chứng từ lên",
     "qsczm":"Vui lòng tải lên chứng từ",
     "tj":"Nộp",
     "czjl":"Hồ sơ gửi tiền",
     "ddh":"KHÔNG.",
     "wsh":"Chưa được xem xét",
     "ywc":"Hoàn thành",
     "bz":"Tên: ",
     "sl2":"Số lượng: ",
     "sj":"Thời gian: ",
     "srsl":"Nhập số lượng...",
     "dd2":"Lấy: ",
     "qskgzflhd":"Hãy luôn chú ý đến các hoạt động phúc lợi, chúng tôi sẽ phát hành chúng theo thời gian",
     "hdlb":"Danh sách sự kiện",
     "ckxq":"Xem chi tiết",
     "wdjl":"Phần thưởng của tôi",
     "yiji":"Cấp độ 1",
     "erji":"Cấp độ 2",
     "sanji":"Cấp 3",
     "je":"Số lượng",
     "sj2":"Thời gian",
     "yyxz":"Ngôn ngữ",
     "tcdl":"Đăng xuất",
     "je2":"Số tiền (USD)...",
     "qsrje":"Nhập số tiền",
     "jsdz":"Địa chỉ nhận...",
     "qsrjsdz":"Nhập địa chỉ nhận",
     "sjdz":"Đến thực tế: ",
     "sxf":"Phí: ",
     "txsm1":"Việc rút tiền yêu cầu phí 5%, phí này cần được nút mạng xác nhận trước khi có thể ghi có",
     "txsm2":"Vui lòng không chuyển tiền điện tử cho người lạ",
     "tz":"Thông báo",
     "wdyq":"Lời mời của tôi",
     "yhid":"UID",
     "hdjl":"Nhận phần thưởng USD",
     "yqsm":"Mời bạn bè của bạn tham gia định lượng Ai, thuê máy khai thác và giao dịch sản phẩm để nhận phần thưởng tiền điện tử",
     "yqsy":"Thu nhập từ lời mời",
     "yqrs":"Số người được mời",
     "tgljyq":"Mời qua liên kết",
     "lj":"liên kết",
     "yqm":"Mã mời",
     "cbtb":"Gửi và rút tiền",
     "jymx":"Chi tiết giao dịch",
     "yqhyjl":"Phần thưởng khi mời bạn bè",
     "aidd":"Lệnh giao dịch AI vàng",
     "jdls":"Lịch sử khoản vay",
     "etfdd":"Lệnh ETF",
     "jmhbdd":"Đơn đặt hàng tiền điện tử",
     "whdd":"Lệnh ngoại hối",
     "gpdd":"Lệnh chứng khoán",
     "qx":"Hủy bỏ",
     "zc":"Tài sản",
     "zzc":"Tổng tài sản",
     "ky":"Có sẵn",
     "zh2":"Đã chuyển đổi (USDT)",
     "xzbz":"Lựa chọn: ",
     "sztkts":"Quan trọng: Vui lòng vào Trung tâm bảo mật để đặt mật khẩu giao dịch",
     "jymm":"Mật khẩu giao dịch",
     "szjymm":"Đặt mật khẩu giao dịch",
     "qsrjymm":"Mật khẩu giao dịch",
     "zdsl":"Số lượng tối thiểu.",
     "bq":"Thẻ(Bản ghi nhớ)",
     "qsrbq":"Nhập thẻ",
     "yhktx":"chuyển khoản ngân hàng",
     "yhmc":"tên ngân hàng",
     "qsryhmc":"Nhập tên ngân hàng",
     "yhzh":"Tài khoản ngân hàng",
     "qsryhzh":"Nhập số tài khoản ngân hàng",
     "gjhkdm":"Mã SWIFT",
     "qsrgjhkdm":"Nhập mã SWIFT",
     "yhdz":"địa chỉ ngân hàng",
     "qsryhdz":"Nhập địa chỉ ngân hàng",
     "skrxm":"Tên người nhận",
     "qsrskrxm":"Nhập tên người nhận thanh toán",
     "skrdh":"Số điện thoại người nhận thanh toán",
     "qsrskrdh":"Nhập số điện thoại của người nhận thanh toán",
     "skrdz":"Địa chỉ người nhận thanh toán",
     "qsrskrdz":"Nhập địa chỉ người nhận thanh toán",
     "tbjl":"Hồ sơ rút tiền",
     "fzcg":"Đã sao chép thành công",
     "aqzx":"Trung tâm bảo vệ",
     "yxrz":"xác thực email",
     "ybd":"ràng buộc",
     "wbd":"Không giới hạn",
     "yrz":"Đã xác minh",
     "wrz":"Không công nhận, không chứng nhận",
     "ts":"Để bảo vệ tài khoản của bạn, bạn nên liên kết địa chỉ email của mình",
     "qsryxdz":"Nhập email",
     "dlmm":"Mật khẩu đăng nhập",
     "mbwtsz":"Cài đặt vấn đề bảo mật",
     "mbwt":"Vấn đề an ninh",
     "qtxda":"Hãy điền câu trả lời",
     "zyts":"Quan trọng: ",
     "zytsCont":"Vui lòng không tiết lộ câu trả lời bảo mật và mã xác minh, đồng thời ghi nhớ câu hỏi bảo mật, điều này sẽ giúp bạn khôi phục mật khẩu của mình.",
     "qsrxmm":"Nhập mật khẩu mới",
     "sydqmmcz":"Đặt lại bằng mật khẩu hiện tại",
     "zhmm":"Vấn đề bảo mật để lấy lại mật khẩu",
     "ysz":"Đã được chuẩn bị",
     "tg":"phớt lờ",
     "qsrdlmm":"Nhập mật khẩu của bạn",
     "bzxz":"Lựa chọn: ",
     "zwsj":"Không có dữ liệu",
     "qd":"ĐƯỢC RỒI",
     "zsgd":"Cho xem nhiều hơn",
     "zdss":"Kích thước lô tối thiểu",
     "mnjy":"Giao dịch mô phỏng",
     "sx":"Lọc",
   },
   "zb":{
     "tgdd":"Đơn đặt hàng được quản lý bằng AI",
     "tgz":"Bị giam giữ",
     "ysh":"Đã chuộc",
     "shz":"Trong sự chuộc lại",
     "zq":"Xe đạp: ",
     "tian":"Ngày",
     "syl2":"Tỷ lệ lợi nhuận: ",
     "rgjg":"Giá thuê bao: ",
     "rgjg2":"Giá thuê bao",
     "xdsj":"Thời gian phục vụ: ",
     "yhl":"Có lợi nhuận: ",
     "syts":"Số ngày còn lại: ",
     "sh":"chuộc lỗi",
     "syl":"Tỷ lệ lợi nhuận",
     "bz":"Tên",
     "dl":"Tỷ giá",
     "tgts":"Ngày tổ chức: ",
     "tgsl":"Số lượng hosting",
     "qsrtgsl":"Nhập số lượng hosting",
     "dbxe":"Hạn mức giao dịch duy nhất",
     "ljtg":"Lưu trữ ngay bây giờ",
     "zztg":"Tiền đang bị tạm giữ",
     "yjjrsy":"Thu nhập ước tính ngày hôm nay",
     "ljsy":"Thu nhập tích lũy",
     "tgzdd":"Ra lệnh tạm giữ",
     "ljzc":"Chuyển ngay",
     "gz":"Luật lệ",
     "cpzq":"Chu kỳ sản phẩm",
     "gm":"Mua",
     "ts":"Quan trọng",
     "shts":"Bạn đang trong quá trình thực hiện quy đổi và bạn sẽ mất 5% nếu quy đổi trước hạn. Bạn có chắc chắn đổi quà không?",
     "xgcs":"Giới hạn số lần mua",
   },
   "dk":{
     "dk":"Khoản vay",
     "dkzh":"Tài khoản cho vay",
     "yzsf":"Xác minh danh tính của bạn và nhận thêm số tiền cho vay!",
     "ksyz":"Bắt đầu xác minh",
     "wxj":"Tôi muốn mượn...",
     "dkqx":"Thời hạn vay (ngày): ",
     "mrll":"Lãi suất hàng ngày: ",
     "lxze":"Tổng tiền lãi: ",
     "dkts":"Khoản vay không bị tính lãi trong 3 ngày và lãi có thể được trả sau đó",
     "xzj":"Vay ngay bây giờ",
     "wyydbzx":"Đồng ý",
     "dkfwxy":"<Thỏa thuận dịch vụ cho vay>",
     "dkfwxy2":"Thỏa thuận dịch vụ cho vay",
     "dkysxy":"Thỏa thuận bảo mật khoản vay",
     "dkjl":"Lịch sử khoản vay",
     "hth":"KHÔNG.",
     "yfk":"Đã giải ngân",
     "lx":"Quan tâm: ",
     "zhke":"Tổng số tiền hoàn trả: ",
     "znj":"Phí thanh toán chậm: ",
     "znjl":"Mức phí trễ hạn: ",
     "yqts":"Số ngày quá hạn: ",
     "qhk":"Hoàn lại",
     "tpsc":"Vay tín dụng (tải lên hình ảnh)",
     "fwxx":"Thông tin nhà ở",
     "srzm":"Bằng chứng về thu nhập (mối quan hệ việc làm)",
     "yhmx":"thông tin chi tiết ngân hàng",
     "zjz":"ảnh giấy tờ tùy thân",
     "ljdk":"Vay ngay bây giờ",
     "xm":"Tên",
     "ndxm":"Tên của bạn",
     "qsrndxm":"Nhập tên của bạn",
     "gj":"Quốc gia",
     "ndgj":"Quốc gia của bạn",
     "qsrndgj":"Nhập quốc gia của bạn",
     "dz":"Địa chỉ",
     "nddz":"Địa chỉ của bạn",
     "qsrnddz":"Nhập địa chỉ của bạn",
     "csrq":"Ngày sinh",
     "ndcsrq":"Ngày sinh của bạn",
     "qsrndcsrq":"Nhập ngày sinh của bạn",
     "dhhm":"Số điện thoại",
     "nddhhm":"Số điện thoại của bạn",
     "qsrnddhhm":"Nhập số điện thoại của bạn",
     "zj":"Các tài liệu",
     "sfzm":"Bản sắc tích cực",
     "qscsfzm":"Tải lên mặt tích cực của danh tính của bạn",
     "sffm":"Ngược lại với danh tính",
     "qscsffm":"Tải lên mặt sau danh tính của bạn",
     "ddqr":"Xác nhận đơn hàng",
     "jk":"Khoản vay: ",
     "dkqx2":"Thời hạn cho vay: ",
     "qrxd":"Xác nhận đơn hàng",
     "yhkxq":"Chi tiết số tiền phải trả",
     "hkqr":"Xác nhận hoàn trả",
     "yhk":"Đến hạn trả nợ: ",
     "jksj":"Thời gian vay: ",
     "ljhk":"Trả hết ngay lập tức",
   },
   "jy":{
     "rq":"ngày",
     "qqjy":"Bản ghi tùy chọn",
     "hyjy":"Hợp đồng",
     "qqhy":"Tùy chọn",
     "dqwt":"Chưa giải quyết",
     'wtz':"Trong ủy quyền",
     "hyjl":"Hồ sơ hợp đồng",
     "shou":"Rất nhiều",
     "dk":"Ồ: ",
     "zhjg":"Muộn nhất: ",
     "jyfy":"Phí giao dịch: ",
     "kfsj":"Giờ mở cửa: ",
     "gg":"Đòn bẩy: ",
     "pl":"Lô hàng: ",
     "kpj":"Giá mở cửa: ",
     "yk":"Lợi nhuận và thua lỗ: ",
     "cd":"Hủy đơn hàng",
     "jsj":"Giá thanh toán: ",
     "fx":"Phương hướng: ",
     "jgsj":"Thời gian giao hàng: ",
     "gb":"Đóng",
     "jxxd":"Tiếp tục",
     "xj":"Giới hạn: ",
     "gm":"Mua: ",
     "sl":"Số lượng",
     "fy":"Trị giá: ",
     "tzbzj":"Điều chỉnh lề",
     "zyzs":"Chốt lãi và dừng lỗ",
     "pc":"Đóng vị thế",
     "mr":"Mua",
     "zjbzj":"Tăng ký quỹ",
     "jsbzj":"Giảm ký quỹ",
     "yxhy":"giao dịch hợp đồng: ",
     "cc":"(Các) vị trí: ",
     "cc2":"Chức vụ",
     "cwbzk":"Ký quỹ vị thế: ",
     "zdzjbzj":"Mức tăng ký quỹ tối đa: ",
     "zjbzj2":"Tăng ký quỹ: ",
     "qsrzbzj":"Vui lòng nhập số tiền đặt cọc",
     "yxhy2":"vĩnh viễn",
     "kp":"Có thể bằng phẳng",
     "zhang":"Mở",
     "xj2":"Giới hạn",
     "zy":"chốt lời",
     "zs":"Chặn đứng tổn thất",
     "ssjyzl":"Tìm kiếm loại giao dịch",
     "ddb":"Quyển sổ đặc Mua hàng",
     "di":"L: ",
     "gao":"H: ",
     "gb2":"C: ",
     "fz":"Phút",
     "mai":"Mua: ",
     "zhang2":"Tăng lên",
     "tie":"Ngã",
     "sy":"Trở lại",
     "kz":"Tăng giá",
     "kt":"Giảm giá",
     "bndy":"Không thể thấp hơn",
     "sxbzj":"Tiền đặt cọc bắt buộc: ",
     "ky":"Có sẵn: ",
     "sj":"Chợ",
     "mc":"Bán",
     "zxtzsl":"Số lượng tối thiểu",
     "min":"Số tiền tối thiểu",
     "max":"Số tiền lớn nhất",
     "yebz":"Thiếu cân bằng",
     "ddz":"Chờ",
     "wtzl":"Số tiền hoa hồng: ",
     "wtjg":"Giá hoa hồng: ",
     "ycd":"Đã hủy",
     "lswt":"lịch sử",
     "qsrzyjg":"Vui lòng nhập giá chốt lời",
     "qsrzsjg":"Vui lòng nhập giá dừng lỗ",
     "ccsl":"Số lượng vị trí: ",
     "ccjg":"Giá vị trí: ",
     "ggbs":"Tận dụng nhiều: ",
     "zy2":"Lấy lợi nhuận: ",
     "zs2":"Chặn đứng tổn thất: ",
     "zje":"Số tiền trả một lần: ",
     "ss":"Rất nhiều: ",
     "kcjg":"Giá mở cửa: ",
     "bzjl":"Tỷ lệ ký quỹ: ",
     "lscc":"Vị trí lịch sử",
     "gmj":"Giá mua: ",
     "guadan":"Danh sách hàng chờ",
     "dqjg":"Giá hiện tại: ",
     "gdjg":"Giá lệnh chờ: ",
     "pcjg":"Giá đóng cửa: ",
     "ccsj":"Thời gian nắm giữ vị thế: ",
     "gdsj":"Thời gian chờ xử lý lệnh: ",
     "pcsj":"Thời gian đóng cửa: ",
     "fdjyk":"Lãi lỗ ròng thả nổi",
     "pcsl":"Số lượng đóng",
     "qrpc":"Xác nhận đóng vị thế",
     "ypc":"Vị thế đã đóng",
     "ss2":"Rất nhiều",
     "qsrss":"Nhập kích thước lô",
   },
   "gjrz":{
     "sfyz":"Chứng nhận KYC",
     "t1":"1. Hỗ trợ hình ảnh định dạng JPG, JPEG hoặc PNG nhỏ hơn 8M.",
     "t2":"2. Ảnh CMND phải rõ ràng và không được phép sửa đổi hoặc chặn. Chân dung, số CMND và tên phải được nhìn thấy rõ ràng.",
     "t3":"3. Ảnh phải được chụp không đội mũ và không nên trang điểm. Nét mặt của người cầm tài liệu phải được nhìn thấy rõ ràng và toàn bộ cánh tay phải lộ ra ngoài.",
     "t4":"ĐƯỢC RỒI",
     "bh":"Từ chối",
     "shz":"Đổi thưởng",
     "shtg":"Kỳ thi đã qua",
     "nyrzcg":"Bạn đã được xác thực thành công",
     "sczjz":"Tải ảnh CMND lên",
     "sczjzmz":"Tải lên ảnh mặt trước của giấy tờ tùy thân của bạn",
     "sczjbmz":"Tải lên ảnh mặt sau CMND của bạn",
     "scgrqmz":"Tải lên ảnh chụp CMND của bạn trên tay",
     "gjlb":"Danh sách quốc gia",
     "qxzgjlb":"Chọn quốc gia/khu vực",
     "zsxm":"Tên thật",
     "qsrzsxm":"Nhập tên thật của bạn",
     "zjlx":"Loại chứng chỉ: ",
     "zjhm":"số ID",
     "qsrzjhm":"Nhập số ID của bạn",
     "khh":"Ngân hàng mở tài khoản",
     "qsrkhh":"Nhập ngân hàng mở tài khoản",
     "yhkh":"Số thẻ ngân hàng",
     "qsryhkh":"Nhập số thẻ ngân hàng",
   },
   "status":{
     "statusText":['Không thành công','Đang xem xét','Thành công'],
   },
   "download":{
     "t1":"Giao dịch di động, mọi lúc, mọi nơi",
     "xz":"Tải xuống",
   },
   "langNew":{
     "jmm": "Mật khẩu cũ",
     "qsrjmm": "Vui lòng nhập mật khẩu cũ của bạn",
     "szhb": "tiền điện tử",
     "gjs": "Kim loại",
     "ny": "Năng lượng",
     "yy": "thô",
     "jy": "Buôn bán",
     "jmhb": "tiền điện tử",
     "yxhy": "Hợp đồng vĩnh viễn",
     "gdjy": "danh sách hàng chờ",
     "khh": "Tài khoản đang mở",
     "qsrkhh": "Vui lòng nhập ngân hàng",
     "yhkh": "Tài khoản ngân hàng",
     "qsryhkh": "Vui lòng nhập số tài khoản ngân hàng",
     "mnzh":"tài khoản demo",
     "zjjypt":"Nền tảng giao dịch tốt nhất",
     "brjmzndxq":"Phần mềm này đáp ứng mọi nhu cầu của bạn với chuyên môn kỹ thuật tốt nhất",
     "jx":"Tiếp tục",
     "yssm":"Cam kết bảo mật",
     "fxqzc":"Chính sách chống rửa tiền",
     "jgxkz":"Giấy phép quy định",
     "ckgd":"Hơn",
     "gd":"Hơn",
     "dd":"Đặt hàng",
     "ckdd":"Xem đơn đặt hàng",
     "yxdd":"vĩnh viễn",
     "qqdd":"Tùy chọn",
     "hand":"Tôi rất nhiều= ",
     "lxwm":"Liên hệ chúng tôi",
     "tpfzl":"Đặt hình ảnh của bạn ở đây hoặc ",
     "liulang":"duyệt qua",
     "zctpgs":"Hỗ trợ: JPG, JPEG2000, PNG",
     "ysr":"Thu nhập hàng tháng",
     "ndysr":"Thu nhập hàng tháng của bạn",
     "qsrndysr":"Nhập thu nhập hàng tháng của bạn",
     "yqtzje":"Số tiền đầu tư dự kiến",
     "qsrtzje":"Nhập số tiền đầu tư dự kiến",
     "zszh":"Tài khoản thực",
     "qdl":"Làm ơn đăng nhập",
     "zx": "Yêu thích",
     "hkdz":"Địa chỉ trả nợ",
     "dkje":"Số tiền vay: ",
     "zlx":"Tổng lãi: ",
     "hkze":"Tổng số tiền hoàn trả: ",
     "qcz":"Đi để nạp tiền",
     "yebz":"Số dư của bạn không đủ, vui lòng nạp tiền",
     "dhje":"Số tiền phải hoàn trả：",
     "hkjl":"Lịch sử trả nợ：",
     "hkje":"Số dư khả dụng：",
     "kyye":"Số tiền trả nợ：",
     "qb": 'Tất cả',
     "lmc": "Tên chuỗi：",
     "search": "Tìm kiếm",
     "mrjg":"Giá",
     "lxkf":"kết nối",
     "wyj":"thiệt hại thanh lý",
     "yxsj":"trong tiến trình：",
     "jssj":"Hoàn thành：",
     "hksj":"Trả nợ：",
     "sysj":"Thời gian còn lại：",
     "jkqx":"Thời hạn cho vay：",
     "yq":"Quá hạn：",
     "qqss":"Lệnh giao dịch quyền chọn của bạn đã hết hạn và khoản lỗ của bạn là ",
     "qqlr":"Lệnh giao dịch quyền chọn của bạn đã hết hạn và lợi nhuận của bạn là",
     "bz":"Tiền tệ",
     "dzje":"Số tiền nhận được",
     "lxyxzc":"Hỗ trợ qua email",
   },
   "langNew9":{
   "dzje":"Xu hướng thị trường của các sản phẩm giao dịch",
   "lxyxzc":"Bắt đầu hành trình giao dịch kỹ thuật số của bạn",
   "text1":"Bắt đầu bằng cách tạo tài khoản",
   "text2":"Mời bạn bè tham gia MFTG để cùng chơi",
   "text3":"Nạp tiền vào tài khoản của bạn",
   "text4":"Hỗ trợ nhiều lần nạp tiền vào tiền tệ, cho phép bạn nhanh chóng bắt đầu giao dịch",
   "text5":"Bắt đầu giao dịch",
   "text6":"Cung cấp nhiều cặp giao dịch chất lượng cao để lựa chọn và giao dịch vui vẻ tại MFTG",
    "text7":"Mời bạn bè kiếm USDT",
    "text8":"Mời bạn bè kiếm USDT dễ dàng",
    "text9":"Chức năng cho vay trực tuyến",
    "text10":"Khi bạn không có tiền, bạn có thể đăng ký khoản vay, khoản vay sẽ được giải ngân sớm nhất trong ngày",
   "text11":"Giao dịch tất cả các tài sản",
   "text12":"Ngoại hối, tiền điện tử, tương lai, ETF, v.v.",
   },
  "bank":{
    "text1":"Nền tảng quản lý tài chính đáng tin cậy nhất của bạn",
    "text2":"Thông báo tin tức thời gian thực",
    "text3":"Hiểu thông tin thời gian thực về ngành tài chính",
    "text4":"bắt đầu hiểu",
    "text5":"tin tức chớp nhoáng",
    "text6":"Chọn ngân hàng",
    "text7":"thẻ ngân hàng",
    "text8":"Số lượng...",
    "text9":"Thêm thẻ ngân hàng",
    "text10":"tài khoản ngân hàng",
    "text11":"Vui lòng nhập tài khoản ngân hàng",
    "text12":"Mã thẻ",
    "text13":"Vui lòng nhập số ID thẻ",
    "text14":"mã ngân hàng quốc tế",
    "text15":"mã ngân hàng quốc tế",
    "text16":"Vui lòng nhập số điện thoại",
    "text17":"Thêm vào",
    "text18":"Xóa thẻ ngân hàng",
    "text19":"Thực tế đến",
    "text20":"Thông tin rút tiền",
    "text21":"Chọn thẻ ngân hàng",
    "text22":"Ghi chú",
    "text23":"Số tiền rút tối thiểu:",
    "text24":"Không được rút tiền nếu số tiền ít hơn số tiền rút tối thiểu",
    "text25":"• Để đảm bảo an toàn cho tiền, khi chính sách bảo mật tài khoản của bạn thay đổi hoặc mật khẩu thay đổi, chúng tôi sẽ xem xét thủ công việc rút tiền. Vui lòng kiên nhẫn chờ nhân viên liên hệ với bạn qua điện thoại hoặc email.",
    "text26":"• Vui lòng đảm bảo rằng máy tính và trình duyệt của bạn an toàn để tránh thông tin bị giả mạo hoặc rò rỉ.",
    "text27":"• Đối với USD bạn rút, mỗi thao tác có nghĩa là tổng số tài sản hiển thị trên trang rút tiền mà bạn sở hữu sẽ bị giảm đi một lượng tiền rút tương ứng.",
    "text28":"Hồ sơ rút tiền",
    "text29":"Loại tiền pháp định",
  },
  "team":{
    "tdjs":"Giới thiệu đội",
    "wmdtd":"Đội ngũ của chúng tôi",
    "tdjj":"Chúng tôi cung cấp cho nhà giao dịch chi phí giao dịch thấp hơn, khớp lệnh tốt hơn và dịch vụ tài chính an toàn hơn. Tham gia một nhà môi giới giao dịch đẳng cấp thế giới, cho phép bạn dễ dàng tham gia vào thị trường tài chính toàn cầu.",
    "gltdjs":"Giới thiệu đội ngũ quản lý",
    "mc0":"Christian James Oram",
    "mc1":"Ari Cohen",
    "mc2":"David Charles Harrison",
    "mc3":"David Harding",
    "mc4":"Markus Johann Fischer",
    "mc5":"Michael Levine",
    "mc6":"Robin Matthes",
    "mc7":"Satya Raito",
    "zc0":"Giám đốc điều hành(CEO)",
    "zc1":"Giám đốc công nghệ",
    "zc2":"Giám đốc tài chính(CFO)",
    "zc3":"Cố vấn pháp luật",
    "zc4":"Giám đốc điều hành(COO)",
    "zc5":"Giám đốc đầu tư(CIO)",
    "zc6":"Giám đốc tín dụng",
    "zc7":"Giám đốc dữ liệu và trí tuệ nhân tạo",
    "text01":"An ninh và minh bạch",
    "text02":"Chúng tôi luôn chú trọng đến vấn đề bảo mật tài sản người dùng",
    "text03":"Giấy phép quản lý đa quốc gia",
    "text04":"Thỏa thuận bảo vệ tài sản",
    "text05":"Kiểm toán độc lập ba bên",
    "text06":"Điều kiện giao dịch tốt nhất",
    "text07":"Kinh nghiệm giao dịch đỉnh cao",
    "text08":"Hỗ trợ nhiều công cụ giao dịch",
    "text09":"Thực hiện lệnh hiệu quả",
    "text10":"Dữ liệu K-line chuyên nghiệp",
    "text11":"Bạn đã sẵn sàng bắt đầu sự nghiệp cùng chúng tôi chưa?",
    "ljks":"Bắt đầu ngay bây giờ",
    "技术副总裁":"Phó Chủ tịch Công nghệ",
    "公共关系与对外事务总监":"Giám đốc Quan hệ Công chúng và Đối ngoại",
    "首席战略官":"Giám đốc Chiến lược",
    "首席人工智能科学家":"Nhà khoa học Trưởng về Trí tuệ Nhân tạo",
    "首席风险官":"Giám đốc Rủi ro"
  },
  "aiDetail":{
    "syxq":"Chi tiết doanh thu",
    "zsy":"tổng doanh thu",
    "rq":"ngày",
  },
  kdkje: 'Số tiền vay được'
   // "langNew2":{
   //   "sy":"Trang chủ",
   //   "sc":"Chợ",
   //   "sclb":"Danh sách thị trường",
   //   "jy":"Buôn bán",
   //   "zh":"Tài khoản",
   //   "db":"Khoản vay",
   //   "zchm":"Số đăng ký",
   //   "cp":"Sản phẩm",
   //   "tzjd":"Cho vay đầu tư",
   //   "zxzc":"Hỗ trợ trực tuyến",
   //   "xd":"Đặt hàng",
   //   "zzjptgmnr":"Đầu tư vào tương lai của bạn. Phát triển danh mục đầu tư của bạn trong một hệ thống tài chính công bằng và cởi mở.",
   //   "yy":"Ứng dụng",
   //   "pqnr":"Ngân hàng di động phá vỡ các quy tắc truyền thống và cung cấp cho bạn các công cụ quản lý tài chính chính xác.",
   //   "jiami":"Tiền điện tử",
   //   "tgnr":"Bằng cách gửi tiền bằng tiền điện tử, bạn có thêm một lớp bảo mật và đảm bảo xử lý giao dịch nhanh chóng.",
   //   "jyl":"Khối lượng giao dịch 24h",
   //   "ssjmhb":"Danh sách tiền điện tử",
   //   "zchy":"Người dùng đã đăng ký",
   //   "djxz":"Bấm chuột để tải xuống",
   //   "azsc":"Chợ Android",
   //   "pgsd":"Cửa hàng táo",
   //   "bqxx":'©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
   // }
}



// WEBPACK FOOTER //
// ./src/lang/vn.js